// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"53e9fcb6","496":"76739ddb"}[chunkId] + ".chunk.js";
};